var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilters = function SvgFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACB3",
    d: "M4.308 8.442a3.05 3.05 0 0 1 3.046-3.057A3.05 3.05 0 0 1 10.4 8.442a3.05 3.05 0 0 1-3.046 3.057 3.05 3.05 0 0 1-3.046-3.057M13.17 8.442c0-.46.371-.834.83-.834h8.862c.458 0 .83.373.83.834s-.372.833-.83.833H14a.83.83 0 0 1-.83-.833M20.646 16.501a3.05 3.05 0 0 0-3.046 3.057 3.05 3.05 0 0 0 3.046 3.057 3.05 3.05 0 0 0 3.046-3.057 3.05 3.05 0 0 0-3.046-3.057M4.308 19.558c0-.46.372-.834.83-.834H14c.459 0 .83.374.83.834s-.371.834-.83.834H5.138a.83.83 0 0 1-.83-.834"
  })));
};
export { SvgFilters as ReactComponent };